export default __webpack_public_path__ + "static/media/youtube.7d3ae5af.svg";